import settings from 'configurations/application';

const TRACKING_ID = settings.envVars.googleAnalyticsId;

export { TRACKING_ID };
